import { createSlice } from "@reduxjs/toolkit";
import {
  getAllActiveTours,
  // getAllActivePackages,
  // getPackageByURL,
  insertPackageInquiry,
} from "@/services/package.services";
import { getAllActiveSOUPackages } from "@/services/ticket.services";

interface PackageState {
  loading: boolean;
  error: string;
  PackageList: any[];
  SOUPackageList: any[];
  PackageDetails: Record<string, unknown>;
}

const initialState: PackageState = {
  loading: false,
  error: "",
  PackageList: [],
  SOUPackageList: [],
  PackageDetails: {},
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    clearPackageDetails: (state) => {
      state.PackageDetails = initialState.PackageDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveTours.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveTours.fulfilled, (state, action) => {
      state.loading = false;
      state.PackageList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveTours.rejected, (state, action) => {
      state.loading = false;
      state.PackageList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveSOUPackages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveSOUPackages.fulfilled, (state, action) => {
      state.loading = false;
      state.SOUPackageList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveSOUPackages.rejected, (state, action) => {
      state.loading = false;
      state.SOUPackageList = [];
      state.error = action.error.message || "Something went wrong";
    });

    // builder.addCase(getPackageByURL.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getPackageByURL.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.PackageDetails = action.payload;
    //   state.error = "";
    // });
    // builder.addCase(getPackageByURL.rejected, (state, action) => {
    //   state.loading = false;
    //   state.PackageDetails = initialState.PackageDetails;
    //   state.error = action.error.message || "Something went wrong";
    // });

    builder.addCase(insertPackageInquiry.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(insertPackageInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertPackageInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default packageSlice.reducer;
export const { clearPackageDetails } = packageSlice.actions;
